// Класс для управления пин-пульсацией
export type PulseDrawCallback = (pulseProgress: number) => void;

export class PulseAnimator {
  private frameId: number | null = null;
  private running = false;
  private readonly duration: number;
  private readonly draw: PulseDrawCallback;

  public constructor(draw: PulseDrawCallback, duration = 3200) {
    this.draw = draw;
    this.duration = duration;
  }

  public startAnimation(): void {
    if (this.running) {
      return;
    }
    this.running = true;
    this.frameId = requestAnimationFrame(this.animate);
  }

  public stopAnimation(): void {
    if (this.frameId !== null) {
      cancelAnimationFrame(this.frameId);
      this.frameId = null;
    }
    this.running = false;
  }

  private animate = (timestamp: number): void => {
    if (!this.running) {
      return;
    }
    /** Считает, сколько времени прошло с "начала мира" (timestamp всегда глобальный) */
    const elapsed = timestamp % this.duration;
    /** Считает прогресс от 0 до 1, где 1 - это конец анимации */
    const progress = elapsed / this.duration;
    /** Отрисовка текущего состояния пульсации */
    this.draw(progress);
    /* Запрашивает следующий кадр */
    this.frameId = requestAnimationFrame(this.animate);
  };
}
